import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { CaseService, NotificationService } from '@services';
import { Case } from '../models/case.model';
import { catchError, of } from 'rxjs';

export const caseResolver: ResolveFn<Case | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const caseService = inject(CaseService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const caseId = route.paramMap.get('id');
  if (!caseId) {
    return of(null);
  }

  return caseService.get(caseId).pipe(
    catchError((err) => {
      console.error(err);

      switch (err?.status) {
        case 401:
          break;
        default:
          router.navigate(['/404'], {
            skipLocationChange: true,
          }).finally(() => {
            notificationService.error('Failed to load the case.');
          });
          break;
      }

      return of(null);
    }),
  );
};
